import { jsx as _jsx } from "react/jsx-runtime";
export const ProductGalleryImage = ({ item, idx = 0 }) => (_jsx("img", { src: item.path, alt: item.label ?? "Product Image", className: `aem-carousel__galleryImg`, "data-testid": `aem-carousel__gallery-image-${idx}` }));
//# sourceMappingURL=ProductGalleryImage.js.map